import {
  type AttachmentResponseType,
  type AttachmentResponseWithSiteRangeType,
  type DocumentAttachmentResponseType
} from '@shared/generated';
import type { UploadableFile } from '@shared/types/attachment';

export const isDocumentAttachmentResponseType = (
  value: unknown
): value is DocumentAttachmentResponseType => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  return (
    'content_type' in value &&
    'file_name' in value &&
    'original_name' in value &&
    'category' in value &&
    'id' in value &&
    'updated_at' in value &&
    'modified_by' in value &&
    'created_at' in value &&
    'created_by' in value &&
    'file_path' in value &&
    'document' in value
  );
};

export const isAttachmentResponseWithSiteRangeType = (
  attachment:
    | AttachmentResponseWithSiteRangeType
    | AttachmentResponseType
    | DocumentAttachmentResponseType
    | UploadableFile
): attachment is AttachmentResponseWithSiteRangeType => {
  return (
    'content_type' in attachment &&
    'file_name' in attachment &&
    'is_within_range' in attachment &&
    'category' in attachment &&
    'job_id' in attachment &&
    'id' in attachment &&
    'file_url' in attachment &&
    'updated_at' in attachment &&
    'modified_by' in attachment &&
    'created_at' in attachment &&
    'file_path' in attachment &&
    'created_by' in attachment
  );
};

export const isAttachmentResponseType = (
  attachment:
    | AttachmentResponseWithSiteRangeType
    | AttachmentResponseType
    | DocumentAttachmentResponseType
    | UploadableFile
): attachment is AttachmentResponseType => {
  return (
    'content_type' in attachment &&
    'file_name' in attachment &&
    'has_timestamp' in attachment &&
    'category' in attachment &&
    'id' in attachment &&
    'updated_at' in attachment &&
    'created_at' in attachment &&
    'created_by' in attachment
  );
};
